'use client';

import ResponsiveImage from '@/components/ResponsiveImage';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import Swiper from '@/components/Swiper/Swiper';
import Layout from './Layout';
import Shape from './Shape';
import BackgroundImage from './BackgroundImage';

import { Autoplay } from 'swiper/modules';

const WithSlider = props => {
  const { list = [], rightSideChildren, align } = props;

  return (
    <div className='flex flex-col lg:flex-row gap-x-16 gap-y-6 lg:gap-y-12 min-h-full text-center sm:text-start'>
      <div
        className={cn('lg:flex-1 w-full max-w-xl lg:w-96', {
          'self-center': align === 'center'
        })}
      >
        <Swiper
          breakpoints={{}}
          slidesPerView={1}
          className='[&_.swiper-pagination-bullet]:!mt-10 lg:[&_.swiper-pagination]:!w-fit'
          autoplay={{
            delay: 10_000,
            disableOnInteraction: false
          }}
          loop
          modules={[Autoplay]}
        >
          {list.map(({ title, subtitle, image, leftCta = [], rightCta = [] }, index) => {
            const [cta1, cta2] = leftCta;
            return (
              <div
                className={cn('flex flex-col xl:flex-row gap-y-20 gap-x-32 h-fit flex-1', {
                  'self-center text-center lg:text-start': align === 'center'
                })}
                key={index}
              >
                <div className='flex flex-col gap-6 md:gap-8 xl:gap-12 md:min-w-[50%] justify-center max-w-[41.0625rem]'>
                  <h1>{title}</h1>
                  {subtitle && <div className='prose' dangerouslySetInnerHTML={{ __html: subtitle }} />}
                  {(cta1 || cta2) && (
                    <div className='flex flex-wrap gap-6 w-fit mx-auto lg:mx-0 justify-center'>
                      {cta1 && <Button {...cta1} size='lg' />}
                      {cta2 && <Button {...cta2} variant='link' color='light' />}
                    </div>
                  )}
                </div>
                {image && <ResponsiveImage file={image} priority />}
              </div>
            );
          })}
        </Swiper>
      </div>
      {rightSideChildren}
    </div>
  );
};

export default function Spotlight({ data = {}, rightSideChildren, align = 'start', className }) {
  const { backgroundImage, list = [] } = data;

  return (
    <Layout className={className}>
      <Shape />
      <WithSlider list={list} rightSideChildren={rightSideChildren} align={align} />
      {backgroundImage && <BackgroundImage {...backgroundImage} />}
    </Layout>
  );
}
